// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-nav-container{padding:0px 8px;margin-bottom:16px}", "",{"version":3,"sources":["webpack://src/container/TopNav/TopNav.styles.scss"],"names":[],"mappings":"AAAA,mBACC,eAAA,CACA,kBAAA","sourcesContent":[".top-nav-container {\n\tpadding: 0px 8px;\n\tmargin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
